export const pluraliser = (count: number, singular: string, plural: string) => {
    if (count === 1) {
        return `1 ${singular}`;
    } else {
        return `${count} ${plural}`;
    }
};
